import { UserInfo } from "@/user/class";
import { createStore } from "vuex";

export default createStore({
  state: {
    loginInfo: {
      //
      userId: 0,
      id: "",
      name: "",
      nickname: "",
      role: "",
    },
  },
  getters: {
    getUserInfo(state) {
      return state.loginInfo;
    },
  },
  mutations: {
    setLoginInfo(state, userInfo: UserInfo) {
      //
      // state.loginInfo.userId = userInfo.userId;
      state.loginInfo = userInfo;
    },
    logout(state) {
      state.loginInfo = new UserInfo();
    },
  },
  actions: {},
  modules: {},
});
